import { InfoCircleTwoTone } from '@ant-design/icons';
import { observer } from 'mobx-react-lite';

import { TWO_TONE_ICON_SETTINGS } from '../../../theme/theme';
import { ErrorPage } from '../ErrorPage';
import { ErrorMessage, ErrorTitle } from '../ErrorPage.styled';

import type { ReactNode, ComponentProps } from 'react';

interface NotFoundProps extends Omit<ComponentProps<typeof ErrorPage>, 'children'> {
	readonly entityName?: string;
	readonly children?: ReactNode;
}

export const NotFound = observer(function NotFound({
	entityName = 'Entity',
	children = (
		<>
			<ErrorTitle>{entityName} not found</ErrorTitle>
			<ErrorMessage>This {entityName.toLowerCase()} does not exist. Please try again later.</ErrorMessage>
		</>
	),
	...props
}: NotFoundProps) {
	return (
		<ErrorPage
			{...{
				icon: <InfoCircleTwoTone {...TWO_TONE_ICON_SETTINGS} />,
				...props,
			}}
		>
			<div>{children}</div>
		</ErrorPage>
	);
});
